module.exports = "/packs/type-of-she-creators-image-e7fbdb8537da739b6df1218aec64f4df.png";